module.exports = __webpack_public_path__ + "static/img/dia-bg.28400af9.png";